<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-xv"></a>
<h2 class="fmt"><span class="bold">Hungarian Pronunciation Guide</span></h2>
<p class="noindent">Vowels – Hungarian vowels have approximately the same sounds as do those of other continental European languages. A close vowel is pronounced very close. An acute accent (´) placed over a letter indicates that the vowel is close. Umlauts indicate both quality and quantity of vowel sounds. The short umlaut is made like the German umlaut (¨); the long umlaut is a double acute accent (˝). Vowels are pronounced approximately as follows:</p>
<div class="block">
<p class="noindent">a like <em class="italic">ou</em> in <em class="italic">bought</em></p>
<p class="noindent">á as in <em class="italic">arm</em></p>
<p class="noindent">e as in <em class="italic">met</em></p>
<p class="noindent">é like <em class="italic">a</em> in <em class="italic">cake,</em> or French <em class="italic">thé</em></p>
<p class="noindent">i like <em class="italic">e</em> in the first syllable of <em class="italic">event</em></p>
<p class="noindent">í like <em class="italic">e</em> in <em class="italic">eve</em></p>
<p class="noindent">o as in <em class="italic">obey</em></p>
<p class="noindent">ó as in <em class="italic">old</em></p>
<p class="noindent">ö like <em class="italic">u</em> in <em class="italic">church,</em> or French <em class="italic">le</em></p>
<p class="noindent">ő like <em class="italic">u</em> in <em class="italic">urn</em></p>
<p class="noindent">u like <em class="italic">u</em> in <em class="italic">put</em></p>
<p class="noindent">ú like <em class="italic">o</em> in <em class="italic">two</em></p>
<p class="noindent">ü as in German Müller or French <em class="italic">tu</em></p>
<p class="noindent">ű as in German Führer or French <em class="italic">rue</em></p>
</div>
<a id="VPS-xvi"></a>
<p class="noindent">Consonants – Except as noted below, consonants have approximately the same value as in English:</p>
<div class="block">
<p class="noindent">c, cz like <em class="italic">ts</em> in <em class="italic">fits</em> or German <em class="italic">Zug</em></p>
<p class="noindent">cs like <em class="italic">ch</em> in <em class="italic">church</em></p>
<p class="noindent">gy like <em class="italic">d</em> plus a glide sound as in <em class="italic">endure</em> or <em class="italic">mon dieu</em></p>
<p class="noindent">j like <em class="italic">y</em> in <em class="italic">yoke</em></p>
<p class="noindent">l followed by y or j approximates <em class="italic">ll</em> French <em class="italic">fillette</em></p>
<p class="noindent">s like <em class="italic">sh</em> in <em class="italic">ship</em></p>
<p class="noindent">sz like <em class="italic">s</em> in <em class="italic">sail</em></p>
<p class="noindent">y as in <em class="italic">yet</em>, except that final y is equal to i</p>
<p class="noindent">zs like <em class="italic">s</em> in <em class="italic">usual</em></p>
</div>
<p class="noindent">Accent – The main stress is always placed on the first vowel in each word.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// guide.vue?6d64ef9e